import React from 'react'
import Traduction from 'Components/Traduction'
import Select from 'Components/Select'
import Constants from 'EurestoFonction/Constants'
import DataComponent from '../../../DataComponents/index'
import Grid from '@material-ui/core/Grid'
import User from 'EurestoClass/User'
import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState)},
      ...newState
    }
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getFamille()
    }
  }

  getFamille = async () => {
    const result = await ApiRequest(project.api + 'gestion', {
      requete: 'famille',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if(result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle && result.results.libelle.length > 0 && result.results.libelle[0].text,
        libelle: result.results.libelle,
        abrege: result.results.abrege,
        famille_id: result.results.famille_id,
        type: result.results.type,
        activite: result.results.activite,
        type_tva_id: result.results.type_tva_id,
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = _ => {
    this.setState({
      libelle: undefined,
      abrege: undefined,
      famille_id: undefined,
      action: 'add',
      type: undefined,
      activite: undefined,
      type_tva_id: undefined,
      key: Utils.getRandomNumber()
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'gestion', {
      requete: 'famille',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      abrege: this.state.abrege,
      famille_id: this.state.famille_id,
      type: this.state.type,
      activite: this.state.activite,
      type_tva_id: this.state.type_tva_id,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'gestion', {
      requete: 'famille',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = {...EurestoClone(this.state.saveState)}
      newState.key = Utils.getRandomNumber();
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="flex-start"
            alignItems="stretch">
        <Traduction
          key={autoFocus}
          autoFocus={autoFocus}
          title={EurestoI18n.t('commun:Nom')}
          onChange={this.onChangeState}
          name={'libelle'}
          disabled={disabled}
          data={this.state.libelle !== undefined ? this.state.libelle : []}
          type={Constants.typeSaisie.SaisieLibre}
        />
        <Traduction
          title={EurestoI18n.t('commun:Abrégé')}
          onChange={this.onChangeState}
          name={'abrege'}
          disabled={disabled}
          data={this.state.abrege !== undefined ? this.state.abrege : undefined}
          type={Constants.typeSaisie.SaisieLibre}
        />
        {this.state.sub && <DataComponent
          title={EurestoI18n.t('commun:Famille')}
          name="famille_id"
          disabled={disabled}
          type={Constants.typeSaisie.ComboSimple}
          onChange={this.onChangeState}
          data={this.state.famille_id}
          object={Constants.donnee.famille}
          module={Constants.module.GESTION}
          search={{ famille_id: null }}/>}
        {!this.state.sub && <Select
          title={EurestoI18n.t('commun:Type')}
          name="type"
          disabled={disabled}
          options={Constants.usefullObjectStatic[Constants.module.GESTION+'-'+Constants.donnee.famille].type.filter(o => o.condition ? o.condition() : true).map(o => ({
            label: o.libelle,
            value: o.id
          }))}
          value={this.state.type !== undefined ? this.state.type : -1} onChange={this.onChangeState}/>}
        <DataComponent
          title={EurestoI18n.t('commun:Activité')}
          name="activite"
          disabled={disabled}
          type={Constants.typeSaisie.ComboMulti}
          onChange={this.onChangeState}

          data={this.state.activite}
          object={Constants.donnee.activite}
          module={Constants.module.COMMUN}/>
        <DataComponent
          title={EurestoI18n.t('commun:Taux TVA')}
          name="type_tva_id"
          disabled={disabled}
          type={Constants.typeSaisie.ComboSimple}
          onChange={this.onChangeState}

          data={this.state.type_tva_id}
          object={Constants.donnee.taux_tva}
          module={Constants.module.GESTION}
          search={{ region_id: User.Entite.get().type === Constants.access.ETABLISSEMENT ? User.Entite.get().region_tva_id || 1 : 1 }}/>
      </Grid>
    )
  }

  render () {
    return (
      <EurestoForm key={this.state.key}
                   {...this.props.formProps}
                   libelle={this.state.defaultLibelle}
                   action={this.state.action}
                   isAllow={this.props.isAllow}
                   onSave={this.onSave}
                   onCancel={this.onCancel}
                   onDelete={this.onDelete}
                   onArchive={this.onArchive}
                   onView={this.onView}
                   libelleAdd={!this.props.sub && EurestoI18n.t('commun:Nouvelle famille') || (EurestoI18n.t('commun:Nouvelle sous-famille de la famille') + ' [' + ']')}
                   children={this.form}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Gestion/Famille.js